var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 91,
    height: 91,
    fill: "none",
    viewBox: "0 0 91 91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#C20101",
    strokeLinecap: "round",
    strokeWidth: 5.6,
    clipPath: "url(#alertClip)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C20101",
    strokeLinejoin: "round",
    d: "M45.32 70.52a1.4 1.4 0 100 2.8 1.4 1.4 0 000-2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    d: "M45.32 59.32V31.33"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M51.37 7.11a6.74 6.74 0 00-12.1 0L3.92 79.13a5.68 5.68 0 005.1 8.18h72.6a5.68 5.68 0 005.1-8.18L51.37 7.11z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "alertClip"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.53.54H90.1v89.57H.53z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.6235dad431c05d7a4ca3576e512597ce.svg";
export { ForwardRef as ReactComponent };